(function(){
    'use strict';

    angular
        .module('elogbooks.user.preferences')
        .controller('UserPreferencesGeneralController', UserPreferencesGeneralController);

    function UserPreferencesGeneralController(
        userManager,
        userResponse,
        userPreferencesCollection,
        modulesService
    ) {
        var vm = this;
            vm.user = userResponse;
            vm.userPreferences = userPreferencesCollection.userPreferences;
            vm.userPreferencesCollection = userPreferencesCollection;
            vm.getPreference = userManager.getPreference;
            vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
            vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
    }
})();
